import { QueryClient } from '@tanstack/react-query';
import { isAxiosError } from 'axios';
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (error && isAxiosError(error)) {
          const errorCode = error.response?.status;
          // Don't retry for client errors
          if (errorCode && errorCode >= 400 && errorCode < 500) {
            return false;
          }
        }
        // Retry up to 3 times
        if (failureCount >= 3) {
          return false;
        }
        return true;
      }
    },
    mutations: {
      onError: e => {
        if (isAxiosError(e)) {
          switch (e.response?.status) {
            case 401:
            case 403:
              {
                return;
              }
            default:
              {
                console.error(e);
              }
          }
        }
      }
    }
  }
});